import { cn } from "@/lib/cn";
import {
  STATUS_DOT_CLASS,
  STATUS_TONE_CLASS,
  statusLabelFor,
  statusToneFor,
} from "@/lib/application-status";

export function StatusBadge({
  status,
  label,
  size = "md",
}: {
  status: string;
  label?: string;
  size?: "sm" | "md";
}) {
  const tone = statusToneFor(status);
  const display = statusLabelFor(status, label);

  return (
    <span
      className={cn(
        "inline-flex max-w-full items-center gap-1.5 rounded-full font-semibold ring-1 ring-inset",
        STATUS_TONE_CLASS[tone],
        size === "sm" ? "px-2 py-0.5 text-[11px]" : "px-2.5 py-1 text-xs",
      )}
      title={display}
    >
      <span
        className={cn(
          "shrink-0 rounded-full",
          STATUS_DOT_CLASS[tone],
          size === "sm" ? "size-1.5" : "size-2",
        )}
        aria-hidden
      />
      <span className="truncate">{display}</span>
    </span>
  );
}
